import React from "react";
import { SafeAreaView, Text, View, Platform, StyleSheet } from "react-native";

import { isAppleDevice, isWeb } from "../../../../helpers/utils";
import AppTheme from "../../AppTheme";
import Icons from "../../common/icons/index";

export default function Header(props) {
  const { controller, title, goBack } = props;

  const titleStyle = title?.length < 30 ? styles.title : styles.titleSmall;

  const onGoBack = () => {
    if (typeof goBack == "function") {
      goBack();
    } else {
      controller.goBack();
    }
  };

  return (
    <SafeAreaView style={[styles.container]}>
      <View style={styles.header}>
        <View style={styles.leftContainer}>
          <Icons.Back
            onPress={onGoBack}
            color="#2D3142"
            width={24}
            height={24}
          />
        </View>
        <View style={styles.titleContainer}>
          <Text style={titleStyle}>{title}</Text>
        </View>
      </View>
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  container: {
    height: isAppleDevice ? 120 : 100,
    zIndex: 1,
  },
  header: {
    position: "relative",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    minHeight: 88,
    justifyContent: "center",
  },
  backIcon: {
    width: 24,
    height: 24,
  },

  titleContainer: {
    width: "100%",
    paddingLeft: 50,
    paddingRight: isWeb ? 50 : 30,
  },
  title: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 20,
    lineHeight: 30,
    letterSpacing: 1,
    color: AppTheme.almostBlack,
    textAlign: "center",
  },
  titleSmall: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 14,
    lineHeight: 17,
    letterSpacing: 0.175,
    color: AppTheme.almostBlack,
  },
  leftContainer: {
    position: "absolute",
    left: 6,
    top: 0,
    height: "100%",
    zIndex: 2,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
});
